import { Tag } from '@ads/components-react';
import { useTranslation } from 'react-i18next';

import type { TutorAIDocumentStatus } from '@/shared/api/generated/types/TutorAIDocumentStatus';

import { type DocumentStatusKey, documentStatusKey } from '../../../utils/documentStatus';

export interface FileStatusTagProps {
  readonly status: TutorAIDocumentStatus;
}

const STATUS_TO_TAG: Record<DocumentStatusKey, 'helper' | 'positive' | 'negative'> = {
  pending: 'helper',
  imported: 'positive',
  outOfSync: 'negative',
};

/**
 * Tag de situação de um documento: pendente, importado ou fora de sincronia.
 *
 * Fora de sincronia é `negative` e não `helper` porque exige ação do operador — o índice
 * não corresponde ao arquivo, então o tutor responde com material desatualizado.
 */
export function FileStatusTag({ status }: FileStatusTagProps) {
  const { t } = useTranslation('tutorAI');
  const key = documentStatusKey(status);

  return (
    <Tag
      label={t(`classDetail.documents.status.${key}`)}
      size="sm"
      status={STATUS_TO_TAG[key]}
      custom={{ text: 'text-nowrap' }}
    />
  );
}
